/* GENERATED by scripts/gen-data.mjs — film scene "f-tooling" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_TOOLING: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "chip",
      "id": "br",
      "x": 14,
      "y": 110,
      "w": 132,
      "h": 76,
      "lKey": "films:f-tooling.items.br.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "br",
      "to": "ag"
    },
    {
      "k": "box",
      "id": "ag",
      "x": 178,
      "y": 122,
      "w": 134,
      "h": 56,
      "lKey": "films:f-tooling.items.ag.l",
      "sKey": "films:f-tooling.items.ag.s"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "ag",
      "to": "ui"
    },
    {
      "k": "box",
      "id": "ui",
      "x": 344,
      "y": 122,
      "w": 120,
      "h": 56,
      "lKey": "films:f-tooling.items.ui.l",
      "sKey": "films:f-tooling.items.ui.s"
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "ui",
      "to": "cd"
    },
    {
      "k": "box",
      "id": "cd",
      "x": 496,
      "y": 122,
      "w": 130,
      "h": 56,
      "lKey": "films:f-tooling.items.cd.l",
      "sKey": "films:f-tooling.items.cd.s"
    },
    {
      "k": "note",
      "id": "n1",
      "x": 178,
      "y": 206,
      "lKey": "films:f-tooling.items.n1.l"
    },
    {
      "k": "note",
      "id": "n2",
      "x": 496,
      "y": 36,
      "lKey": "films:f-tooling.items.n2.l"
    }
  ],
  "steps": [
    {
      "on": [
        "br"
      ],
      "hot": [
        "br"
      ],
      "capKey": "films:f-tooling.steps.0.cap"
    },
    {
      "on": [
        "br",
        "ag",
        "w1"
      ],
      "hot": [
        "ag",
        "w1"
      ],
      "capKey": "films:f-tooling.steps.1.cap"
    },
    {
      "on": [
        "br",
        "ag",
        "w1",
        "ui",
        "w2"
      ],
      "hot": [
        "ui",
        "w2"
      ],
      "capKey": "films:f-tooling.steps.2.cap"
    },
    {
      "on": [
        "br",
        "ag",
        "w1",
        "ui",
        "w2",
        "cd",
        "w3",
        "n2"
      ],
      "hot": [
        "cd",
        "w3",
        "n2"
      ],
      "capKey": "films:f-tooling.steps.3.cap"
    },
    {
      "on": [
        "br",
        "ag",
        "w1",
        "ui",
        "w2",
        "cd",
        "w3",
        "n1",
        "n2"
      ],
      "hot": [
        "n1"
      ],
      "capKey": "films:f-tooling.steps.4.cap"
    }
  ]
};
